import * as TypeGraphQL from "type-graphql";
export var AccountLinkingRequestScalarFieldEnum;
(function (AccountLinkingRequestScalarFieldEnum) {
    AccountLinkingRequestScalarFieldEnum["id"] = "id";
    AccountLinkingRequestScalarFieldEnum["userId"] = "userId";
    AccountLinkingRequestScalarFieldEnum["email"] = "email";
    AccountLinkingRequestScalarFieldEnum["provider"] = "provider";
    AccountLinkingRequestScalarFieldEnum["providerAccountId"] = "providerAccountId";
    AccountLinkingRequestScalarFieldEnum["status"] = "status";
    AccountLinkingRequestScalarFieldEnum["verificationToken"] = "verificationToken";
    AccountLinkingRequestScalarFieldEnum["userAgent"] = "userAgent";
    AccountLinkingRequestScalarFieldEnum["ipAddress"] = "ipAddress";
    AccountLinkingRequestScalarFieldEnum["createdAt"] = "createdAt";
    AccountLinkingRequestScalarFieldEnum["expiresAt"] = "expiresAt";
    AccountLinkingRequestScalarFieldEnum["verifiedAt"] = "verifiedAt";
    AccountLinkingRequestScalarFieldEnum["approvedAt"] = "approvedAt";
    AccountLinkingRequestScalarFieldEnum["rejectedAt"] = "rejectedAt";
})(AccountLinkingRequestScalarFieldEnum || (AccountLinkingRequestScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AccountLinkingRequestScalarFieldEnum, {
    name: "AccountLinkingRequestScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AccountLinkingRequestScalarFieldEnum.js.map